import React, { memo } from "react";
import styled, { keyframes } from "styled-components";

const LoaderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoaderDotsWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const scaleDot = keyframes`
  0% {
    transform: scale(0.5);
  }
  25% {
    transform: scale(1);
  }
  75% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(0.5);
  }
`;

const LoaderDot = styled.div`
  margin: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: gray;
  transform: scale(0.5);
  animation: ${scaleDot} 1.2s ease-out infinite;
  &:nth-of-type(2) {
    animation-delay: 0.2s;
  }
  &:nth-of-type(3) {
    animation-delay: 0.3s;
  }
  &:nth-of-type(4) {
    animation-delay: 0.4s;
  }
  &:nth-of-type(5) {
    animation-delay: 0.5s;
  }
`;

const LoaderDotsDef = () => {
  return (
    <LoaderContainer data-test="loader-dots">
      <LoaderDotsWrapper>
        <LoaderDot />
        <LoaderDot />
        <LoaderDot />
      </LoaderDotsWrapper>
    </LoaderContainer>
  );
};

export const LoaderDots = memo(LoaderDotsDef);
